// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const peatBank = defineModel({
  id: "peat-bank",
  batchId: "future",
  name: "Peat bank",
  tags: ["scenery","peat","bank","low-poly","age-of-mcp","future"],
  summary: "A cut bank of peat. Dried as a cheap fuel and a soil amendment.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.46, 0.3, 0.4), color: "#4a3826", position: [-0.04, 0.15, -0.04], rotation: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.1, 0.34), color: "#3c2e1f", position: [0.12, 0.05, 0.1], rotation: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.28, 0.1, 0.18), color: "#56432e", position: [0.1, 0.15, 0.18], rotation: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.42, 0.05, 0.36), color: "#7d8a52", position: [-0.06, 0.32, -0.04], rotation: [0, 0.1, 0] },
      { geometry: new THREE.ConeGeometry(0.05, 0.12, 4), color: "#7d8a52", position: [-0.18, 0.4, -0.12], rotation: [0.1, 0.3, 0.05] },
      { geometry: new THREE.ConeGeometry(0.04, 0.1, 4), color: "#7d8a52", position: [-0.02, 0.4, -0.16], rotation: [0.05, 0.6, -0.1] },
      { geometry: new THREE.BoxGeometry(0.22, 0.07, 0.12), color: "#5c4a30", position: [0.34, 0.035, 0.22], rotation: [0, -0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.07, 0.11), color: "#56432e", position: [0.36, 0.105, 0.2], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.07, 0.1), color: "#5c4a30", position: [0.34, 0.175, 0.22], rotation: [0, -0.25, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.06, 0.09), color: "#3c2e1f", position: [0.36, 0.235, 0.2], rotation: [0, -0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.06, 0.08), color: "#5c4a30", position: [-0.17, 0.03, 0.16], rotation: [0.1, 0.4, 0.05] },
      { geometry: new THREE.BoxGeometry(0.1, 0.05, 0.07), color: "#4a3826", position: [-0.1, 0.025, 0.22], rotation: [0.05, 0.8, 0.1] },
    ],
  animations: [],
});
